import React, { Fragment, useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import bg from "../assets/images/bg.webp";
import FormField from "../components/FormField";
import Frame from "../components/Frame";
import helloU from "../assets/images/hellou.png";

import arrow from "../assets/images/arrow.png";
import axios from "axios";
import hl_web from "../assets/images/hl-web.png";
import hl_mobile from "../assets/images/hl-mobile.png";
import Spinner from "../components/Spinner";
import * as yup from "yup";

const isDev = process.env.NODE_ENV === "development";
const url = isDev
  ? "https://mainbackend.woogiu.com/woogi/0.1/actor/cgi.php"
  : // : "/woogi/0.1/actor/cgi.php";
    "https://mainbackend.woogiu.com/woogi/0.1/actor/cgi.php";

const ping = (server: string) => {
  return new Promise(async (resolve, reject) => {
    try {
      let started = new Date().getTime();

      await axios.get(
        "//" + server + "/client/dashboard/en/DB_0/dat/1b.dat?t=" + started
      );

      let ended = new Date().getTime();
      resolve(ended - started);
    } catch (error) {
      reject(0);
    }
  });
};

const classes = [
  "bg-green-600",
  "bg-green-300",
  "bg-orange-300",
  "bg-red-400",
  "bg-red-600",
];

type Server = {
  name: string;
  online: number;
  server_host: string;
  responseTime: number;
};

type Language = {
  title: string;
  key: string;
};

type SelectedData = { server?: Server; language?: Language };

type Props = {};

export default function Login({}: Props) {
  const [loading, setLoading] = useState(false);
  const [path, setPath] = useState("login");

  const [data, setData] = useState<{
    serverList: Server[];
    languages: Language[];
    translations: { [key: string]: string[] };
  }>({
    translations: {
      en: [
        "login",
        "login with ClassLink",
        "Sign up",
        "Sign in",
        "Reset nickname",
        "Reset position",
        "Select Server",
        "Login Name",
        "Password",
        "Create a password",
        "Confirm password",
        "Repeat password",
        "Email(optional)",
        "Email address",
        "CHOOSE YOUR SUPER NAME",
        "RANDOMIZE",
        "NEXT",
        "Lang",
        "Hello",
        "Play Now",
        "Go back to Woogi English App, then you should be able to sign in now",
        "Activate your account with a serial code",
        "Activate Account",
        "Reset Password",
        "We have sent a verification email to you ! Please check your email",
        "Congratulations! You have bound your email",
        "You can switch back to the app if it is already op…can open it by clicking the Play Now button below",
        "Loading",
        "Wrong email or password",
        "Success",
        "Current page expired! Please reopen it from the app",
        "Email is invalid",
        "You are blocked to sign up by system",
        "Length of name should be 4-16",
        "Name is already taken",
        "Name is invalid",
        "Failed to connect to server",
        "Wrong name or password",
      ],
    },
  } as any);

  const [triggerClass, setTriggerClass] = useState(false);

  const [selectedData, setSelectedData] = useState<SelectedData>({
    language: { key: "en", title: "English" },
  } as SelectedData);

  const translation =
    data.translations[selectedData.language!.key.toLowerCase()];

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);

      const [_serverList, languages, translations] = await Promise.all([
        await axios.post(url, { cmd: "Server.getEnglishServers" }),
        await axios.post(url, {
          cmd: "awe_translation_WeWebglTranslation.getLanguages",
          type: 1,
        }),
        await axios.post(url, {
          cmd: "awe_translation_WeWebglTranslation.getUITranslations",
        }),
      ]);

      setData((old) => ({
        ...old,
        serverList: _serverList.data.http,
        languages: Object.keys(languages.data.data)?.map((key: string) => ({
          key: key,
          title: languages.data.data[key],
        })),
        translations: translations.data.data,
      }));

      !selectedData?.server &&
        setSelectedData((old) => ({
          ...old,
          server: _serverList.data.http[0],
        }));

      setLoading(false);
    };

    loadData();
  }, []);

  useEffect(() => {
    axios.post<{ token?: string; code?: string }>(url, {
      cmd: "WoogiOAuth.resetHULoginStatus",
    });
  }, []);

  useEffect(() => {
    let time = setInterval(() => {
      if (data.serverList?.length > 0)
        data.serverList.forEach((server: Server, index: number) => {
          ping(server.server_host)
            .then((resp: any) => {
              setData((old) => {
                const serverList = [...old.serverList];
                const server: Server = {
                  ...serverList[index],
                  responseTime: resp,
                };

                serverList.splice(index, 1, server);

                return { ...old, serverList: serverList };
              });
            })
            .catch(console.log);
        });
    }, 5000);

    return () => {
      clearInterval(time);
    };
  }, [data?.serverList]);

  const handleLoginSubmit = async (value: any, actions: any) => {
    actions.setSubmitting(true);

    if (!selectedData?.server) {
      setTriggerClass(true);
      return window.alert(translation[6]);
    }

    const dataToSend = {
      cmd: "WoogiOAuth.signIn",
      name: value.username,
      password: value.password,
      selectServer: selectedData.server.server_host,
      point_server: 1,
      reset_nickname: value.options.includes("reset_nickname") ? 1 : 0,
      reset_pos: value.options.includes("reset_pos") ? 1 : 0,
    };

    const results = await axios.post<{ token?: string; code?: string }>(
      url,
      dataToSend
    );

    if (results.data?.code) {
      if (+results.data?.code === 700)
        return window.open(
          `https://${selectedData.server.server_host}/woogi/0.1/static/changePassword2/change.php`
        );

      if (+results.data?.code === 600)
        actions.setFieldError("password", translation[37]);

      if (+results.data?.code === 601)
        actions.setFieldError("password", translation[37]);

      if (+results.data?.code === 602)
        actions.setFieldError("password", translation[36]);
    }

    const token = results.data?.token;

    if (token) {
      return window.open(
        `https://${selectedData.server.server_host}/woogi/0.1/static/websites/gameeditor/woogiEnglishWebgl.php?token=${token}&v=1`,
        "_self"
      );
    }

    actions.setSubmitting(false);
  };

  const loginSchema = yup.object({
    username: yup.string().required().label(translation[7]),
    password: yup.string().required().label(translation[8]),
  });

  const signupSchema = yup.object({
    username: yup.string().required().label(translation[7]),
    password: yup.string().required().label(translation[8]),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], translation[11])
      .required()
      .label(translation[8]),
    email: yup.string().email(translation[13]).label(translation[13]),
  });

  const handleSignupSubmit = async (value: any, actions: any) => {
    if (!selectedData?.server) {
      setTriggerClass(true);
      return window.alert(translation[6]);
    }

    actions.setSubmitting(true);

    const results = await axios.post(url, {
      cmd: "User1.signUpWE",
      name: value.username,
      password: value.password,
      email: value.email,
      app_code: "",
    });

    if (results.data?.code == 200)
      return window.open(
        `https://${
          selectedData.server?.server_host
        }/woogi/0.1/static/websites/woogienglish/after_sign_up.php?bmail=${
          value?.email ? 1 : 0
        }&token=${results.data.token}&from_hellou=1&username=${value.username}`,
        "_self"
      );

    if (results.data?.code == 404) {
      actions.setFieldError("username", translation[33]);
    }

    if (results.data?.code == 405) {
      actions.setFieldError("username", translation[34]);
    }

    if (results.data?.code == 407) {
      actions.setFieldError("email", translation[31]);
    }

    if (results.data?.code == 408) {
      actions.setFieldError("email", translation[30]);
    }

    actions.setSubmitting(false);
  };

  const saveHUEvent = (event: string) => {
    axios.post<{ token?: string; code?: string }>(url, {
      cmd: "awc_WcMixLogin.saveHUEvent",
      event,
    });

    return null;
  };

  return (
    <div
      className="lg:h-screen lg:w-screen w-full bg-no-repeat bg-cover flex flex-col justify-center"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="lg:absolute w-full lg:top-2 flex items-center lg:items-start flex-col-reverse lg:flex-row lg:justify-between">
        <img
          src={helloU}
          className="w-48 h-48 lg:w-60 lg:h-60 p-2"
          alt="logo"
        />

        <div className="language-bar p-2">
          {data.languages?.map((lan) => (
            <button
              className={`rounded px-2 py-1 text-base text-white ${
                selectedData.language?.key === lan.key &&
                "bg-blue-900 font-medium"
              }`}
              onClick={() =>
                setSelectedData({ ...selectedData, language: lan })
              }
            >
              {lan.title}
            </button>
          ))}
        </div>
      </div>

      <div className="mx-auto z-10 ">
        <Frame>
          {loading && (
            <div className="w-60 h-60 flex justify-center items-center">
              <Spinner />
            </div>
          )}

          {!loading && (
            <Fragment>
              {path === "login" && (
                <Fragment>
                  <h1 className="text-6xl primary-color text-center mb-6">
                    {translation[3]}
                  </h1>
                  <Formik
                    validationSchema={loginSchema}
                    onSubmit={handleLoginSubmit}
                    initialValues={{ username: "", password: "", options: [] }}
                  >
                    {({ isSubmitting }) => (
                      <Form>
                        <FormField
                          placeholder={translation[7]}
                          name="username"
                          type="text"
                        />
                        <FormField
                          type={"password"}
                          name="password"
                          placeholder={translation[8]}
                        />
                        <div
                          role="group"
                          aria-labelledby="options"
                          className="flex flex-1 justify-evenly my-5"
                        >
                          <label className="secondary-heading text-xl lg:text-3xl">
                            <Field
                              className="secondary-heading text-xl lg:text-3xl scale-125 w-10 h-4 -mt-1"
                              type="checkbox"
                              name="options"
                              value="reset_nickname"
                            />
                            {translation[4]}
                          </label>
                          <label className="secondary-heading text-xl lg:text-3xl">
                            <Field
                              className="secondary-heading text-xl lg:text-3xl scale-125 w-10 h-4 -mt-1"
                              type="checkbox"
                              name="options"
                              value="reset_pos"
                            />
                            {translation[5]}
                          </label>
                        </div>
                        {!isSubmitting && (
                          <button className="btn-primary" type="submit">
                            {translation[0].toUpperCase()}
                          </button>
                        )}
                        {isSubmitting && <Spinner />}
                      </Form>
                    )}
                  </Formik>
                  <h4 className="secondary-heading text-center my-4">OR</h4>

                  <div className=" flex flex-1 flex-col space-y-2 lg:space-y-0 lg:space-x-2 lg:flex-row justify-evenly">
                    <button
                      type="button"
                      className="btn-secondary"
                      onClick={() => {
                        saveHUEvent("CLASSLINK_LOGIN");
                        window.open(
                          "https://hellou.heroesleague.us/indexOfClassLink.php",
                          "_self"
                        );
                      }}
                    >
                      {translation[1].toUpperCase()}
                    </button>

                    <button
                      type="button"
                      className="btn-secondary"
                      onClick={() => {
                        saveHUEvent("CLEVER_LOGIN");
                        window.open(
                          "https://hellou.heroesleague.us/indexOfClever.php",
                          "_self"
                        );
                      }}
                    >
                      {translation[38]}
                    </button>
                  </div>

                  <div className="my-2">
                    <h3
                      className="signup-text text-center lg:text-right text-6xl cursor-pointer"
                      onClick={() => {
                        saveHUEvent("BUTTON_SIGNUP");
                        saveHUEvent("PAGE_SIGN_UP");
                        setPath("signup");
                      }}
                    >
                      {translation[2]}
                    </h3>
                  </div>
                </Fragment>
              )}

              {path === "signup" && (
                <Fragment>
                  <h1 className="text-6xl primary-color text-center mb-6">
                    {translation[2]}
                  </h1>
                  <Formik
                    validationSchema={signupSchema}
                    onSubmit={handleSignupSubmit}
                    initialValues={{
                      username: "",
                      password: "",
                      confirmPassword: "",
                      email: "",
                    }}
                  >
                    {({ isSubmitting }) => (
                      <Form>
                        <FormField
                          placeholder={translation[7]}
                          name="username"
                        />
                        <FormField
                          type={"password"}
                          placeholder={translation[9]}
                          name="password"
                        />
                        <FormField
                          type={"password"}
                          placeholder={translation[10]}
                          name="confirmPassword"
                        />
                        <FormField
                          type={"email"}
                          placeholder={translation[12]}
                          name="email"
                        />

                        {!isSubmitting && (
                          <button className="btn-primary" type="submit">
                            {translation[2].toUpperCase()}
                          </button>
                        )}
                        {isSubmitting && <Spinner />}
                      </Form>
                    )}
                  </Formik>
                  <h4 className="secondary-heading text-center my-4">OR</h4>

                  <div className="my-2">
                    <h3
                      className="signup-text text-center text-6xl cursor-pointer"
                      onClick={() => {
                        saveHUEvent("BUTTON_LOGIN");
                        saveHUEvent("PAGE_LOGIN");
                        setPath("login");
                      }}
                    >
                      {translation[3]}
                    </h3>
                  </div>
                </Fragment>
              )}
            </Fragment>
          )}
        </Frame>
      </div>

      <img
        onClick={() => window.open("https://portal.americau.com/")}
        src={hl_web}
        className="hidden lg:block absolute bottom-0 right-0 cursor-pointer"
        alt="Heroes League Game Day"
      />

      <img
        onClick={() => window.open("https://portal.americau.com/")}
        src={hl_mobile}
        className="mb-24 my-5 lg:hidden mx-auto cursor-pointer h-48 w-48"
        alt="Heroes League Game Day"
      />

      <div
        className={`left-0 bottom-0 w-full lg:max-w-sm fixed bg-white shadow-lg rounded-t-lg z-10`}
      >
        <img
          src={arrow}
          alt=""
          className={`transition-all mx-auto -mt-7 pannel-btn ${
            triggerClass ? `rotate-0` : "rotate-180"
          }`}
          onClick={() => setTriggerClass(!triggerClass)}
        />

        <h2 className="px-3 text-2xl lg:4xl pb-2 text-center capitalize">
          {translation[6]}
        </h2>
        <div className="text-gray-900 bg-white">
          <div
            className={`server-list ${
              triggerClass ? "open-pannel" : "close-pannel"
            }`}
          >
            {data.serverList
              ?.sort((a, b) => a.responseTime - b.responseTime)
              .map((server, index: number) => (
                <button
                  onClick={() => setSelectedData({ ...selectedData, server })}
                  key={index}
                  type="button"
                  className={`inline-flex relative justify-between items-center py-2 px-4 w-full text-xl font-primary font-medium border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 ${
                    selectedData?.server?.name == server?.name &&
                    "bg-orange-600 text-white"
                  }`}
                >
                  <span>
                    {server.name} {"(" + server.online + ")"}{" "}
                  </span>
                  <span className=" w-14 flex-row flex justify-between items-center">
                    <span
                      className={`block h-3 w-3 rounded-full ${classes[index]}`}
                    />
                    {server?.responseTime || "--"}
                  </span>{" "}
                </button>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
